module.exports = __webpack_public_path__ + "static/img/materials8.20a37d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materials8.png
// module id = sN/4
// module chunks = 2